import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import LazyLoad from 'react-lazy-load';
import * as actions from '../../../actions/homeData';
import PopUpCategoryNavigation from '../homepage/PopUpCategoryNavigation';
import Modal from '../../common/Modal';
import { showModal, hideModal } from '../../../actions/modal.js';
import { VideoModalBody } from '../../common/VideoModal';
import NotFoundPage from '../NotFoundPage';
import { signout } from '../../../userauth/actions/signinAction';
import Layout from '../Layout';
import Error504 from '../../common/Error504';
import Error503 from '../../common/Error503';
import { generateEvent } from '../../../utils/dataGrinch';

import {
  readCookie,
  readClusterCookie,
  updateClusterCookie,
  createCookie
} from '../../common/Cookie';
import ReferralCongratulations from '../../common/ReferralCongratulations.jsx';
import {
  getLocaleData,
  userAllowLocationForLocale,
  userAllowedLocationForLocale,
  userAllowedLocationForRuntimeLocale
} from '../../../actions/localeBannerApi/localeClientCall';
import { signInCheck } from '../../common/CheckUserStatus';
import { askUserLocation } from '../../../modules/ajio-fetch/utils';
import { postalCodeFetch } from '../../../myaccount/actions/addressBook';
import LocalePopUpForUserLocation from '../../common/LocalePopUpForUserLocation';
import properties from '../../../modules/ajio-util/properties';
import { getLocalStorageLocaleData } from '../../../actions/localeBannerApi/localeClientCall';
import {
  accountCheck,
  socialAuth,
  setSignupSocial
} from '../../../userauth/actions/signinAction.js';
import SignUpSocial from '../../../userauth/components/SignUpSocial';
import { parseJwt } from '../../../utils/loginUtil';
import {
  gtmPagePush,
  gtmPromotionImpressions,
  gtmPromotionCmsImpressions,
  gtmLuxePromotionImpressions,
  gtmLuxePromotionCmsImpressions,
  gtmPromotionClick,
  gtmPromotionCmsClick,
  gtmExtraInfoMeta,
  gtmLuxePromotionClick,
  gtmLuxePromotionCmsClick
} from '../../../modules/ga/GTMdatalayer';
import {
  createGTMBannerViewPortIntersectionObserverDesktop,
  createCmsGTMBannerViewPortIntersectionObserverDesktop,
  triggerLandingPageGtmMetaEvent,
  getBannerComponentPosition
} from '../../../modules/ga/gtmLandingPageMethods';
import {
  GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME,
  GTM_BANNER_COMPONENT_POSITION_CLASS_NAME
} from '../../../modules/ga/gtmConstants';
import screen from '../../../refresh/constants/pageType.constant';
import IndieCollection from './NewIndieCollectionContainerComponent';

import WomenBanner from './WomenBannerComponent';
import { requestType } from '../../../constants/constant.js';

import { DESKTOP_PLATFORM } from '../../mobile/banner/BannerPlatform';
import { BannerComponentJSON } from './BannerComponentDesktopTypeCode';

import { savedCustomerTypeData } from '../../../actions/localeBannerApi/localeClientCall';

import BannerComponentsRenderer from './runtime/BannerComponentsRenderer.js';
import {
  getRuntimeBannersFlag,
  getRuntimeBannersUrlList,
  getReferralFeatureEnableFlag,
  getRefereeEnableFlag,
  getLuxeFlags,
  getClusterFeatureFlagHome
} from '../../../Flags/selectors.js';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import {
  isRuntimeBannersUrlEnabled,
  removeBannerImpressionCookiesOnPageReloaded,
  setLandingPageScrollCookies,
  setLandingPageScroll,
  handleRemainingBundlePromotionImpression
} from '../../../utils/banner';
import BannerModal from '../../../refresh/organism/BannerModal';
import { removeParameters } from '../../../modules/ajio-util/query';
import { sendClickOrImpressionTrackerToJioAds } from '../../../utils/jioAdsRelated';
import { fireOsmosClickTracker } from '../../../utils/osmosPlpImpressionUtils';
import { getVariant } from '../../../refresh/organism/ABFeature/Feature';
import ErrorMessage from '../../common/ErrorMessage';
import { jioAdsAppLaunchEvent, jioAdsLocationEvent, deeplinkLaunchEvent } from '../../../utils/jioAds';
import DressToolModal from '../../common/DressToolModal';

const STORAGE_KEY = 'bannerDesktopListClicked';

class BannerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.gtmBannerViewportObserver = {};
    this.gtmBannersData = [];
    this.gtmBannersImpressionData = {
      banners: [],
      lastPushedAt: -1,
      oldBanners: []
    };
    this.state = {
      showEmailEditSuccess: false,
      isJioAdsLoaded: true
    };
  }

  componentDidUpdate() {
    const { JioAds } = window;
    if (JioAds && this.state.isJioAdsLoaded) {
      console.log("TRACK JIO ADS EVENT jioAdsAppLaunchEvent");
      jioAdsAppLaunchEvent();
      deeplinkLaunchEvent();
      setTimeout(() => {
        let locationInfo = JSON.parse(localStorage.getItem('locationInfo'));
        console.log("🚀 ~ file: BannerComponent.js:140 ~ BannerComponent ~ locationInfo:", locationInfo)
        if(locationInfo){
          const locationData = {
            cartItems: [],
            locationDetails : {
              pincode : '',
              lat : locationInfo?.latitude || '',
              lon : locationInfo?.longitude || ''
            }
          }
          console.log("🚀 ~ file: BannerComponent.js:149 ~ BannerComponent ~ locationData:", locationData)
          jioAdsLocationEvent(locationData)
        }
      }, 1000);
      this.setState({
        isJioAdsLoaded: false
      });
    }
  }

  cleverTapPopup = () => {
    // cleverTap popup
    // TODO: update time in askAgainTimeInSeconds key
    if (typeof clevertap !== 'undefined') {
      // checking clevertap is defined or not
      clevertap.notifications.push({
        titleText: 'Allow AJIO to send fashion deals and more...',
        bodyText:
          'We promise to only send you relevant content and give you updates on your transactions',
        okButtonText: 'Yes',
        okButtonColor: '#176d93',
        rejectButtonText: 'Not now',
        askAgainTimeInSeconds: 5,
        serviceWorkerPath: '/sw.js'
      });
    }
  };

  sendVisibilityEvent({ pgDetails }) {
    let {
      banner: { componentPosition = -1, urlLink = '' } = {},
      bannerImageDetails = [],
      typeCode = '',
      bannerUrlLink = '',
      slotName = ''
    } = pgDetails;
    let eventObj = {};
    eventObj.TypeCode = typeCode;
    if (componentPosition > -1) {
      eventObj.BannerPosition = componentPosition;
    }
    if (urlLink) {
      eventObj.BannerUrlLink = urlLink;
    }

    let siblingsBanners =
      bannerImageDetails.map((item = {}) => {
        let { componentPosition, bannerPosition, urlLink } = item;
        return {
          ParentPosition: componentPosition,
          SibllingPosition: bannerPosition,
          Link: urlLink
        };
      }) || [];

    if (siblingsBanners.length) {
      eventObj.BannerPosition = eventObj.BannerPosition
        ? eventObj.BannerPosition
        : siblingsBanners[0].ParentPosition != undefined
        ? siblingsBanners[0].ParentPosition
        : componentPosition;
      eventObj.ChildrenBanners = siblingsBanners;
    }

    generateEvent({
      Event: 'LandingPageBannerVisibility',
      value: eventObj
    });
  }

  checkMsitePlatform(platform) {
    return DESKTOP_PLATFORM[platform];
  }

  allowUserLocation = () => {
    if (this.props.isRuntimeBannerPage) {
      this.props.updateNonLoginUserLocationUsingRuntimeLocaleChanges();
    } else {
      this.props.updateNonLoginUserLocationLocaleChanges();
    }
    this.props.hideModal('locale-banner-popup');
  };

  checkUserLocationPermissionAccess = async () => {
    var isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window.safari || (typeof safari !== 'undefined' && safari.pushNotification));
    const isQueryFunctionExists = navigator.permissions
      ? _isFunction(navigator.permissions.query)
      : false;
    if (!isSafari && isQueryFunctionExists) {
      navigator.permissions.query({ name: 'geolocation' }).then(async result => {
        if (result.state === 'granted') {
          if (this.props.isRuntimeBannerPage) {
            this.props.updateNonLoginUserLocationUsingRuntimeLocaleChanges();
          } else {
            this.props.updateNonLoginUserLocationLocaleChanges();
          }
        } else if (result.state === 'prompt') {
          const daysDifference = await getLocalStorageLocaleData();
          if (daysDifference === -1 || daysDifference > 5) {
            this.props.showModal('locale-banner-popup');
          }
        }
        // Don't do anything if the permission was denied.
      });
    } else {
      const daysDifference = await getLocalStorageLocaleData();
      const moment = await import(/* webpackChunkName: "static/chunk/moment" */ 'moment').then(
        ({ default: moment }) => moment
      );

      daysDifference === -1 && localStorage.setItem('lastModalClose', moment());
      if (daysDifference === -1 || daysDifference > 5) {
        this.props.showModal('locale-banner-popup');
      }
    }
  };

  handleModalClose = async () => {
    const moment = await import(/* webpackChunkName: "static/chunk/moment" */ 'moment').then(
      ({ default: moment }) => moment
    );
    localStorage.setItem('lastModalClose', moment());
  };

  clickMenuOptions = ()=>{
    console.log('in click func')
    document.getElementById('open-menu-button').click();
  }

  render() {
    const {
      banner = {},
      error = {},
      metaData: { sis = false, name = '' } = {},
      socialLoginInfo = {},
      location: { search = '' } = {},
      runtimeBanners,
      runtimeBannersUrlList,
      isRuntimeBannerPage,
      flags = {},
      newDesignLuxe
    } = this.props;

    // let fixedBtnProps = {
    //   popupBtnText : 'OKAY',
    //   proceedText: 'Go to bag',
    //   popUpAction : () => {
    //     this.props.hideModal("order-summary-popup")
    //   },
    //   proceedAction : function() {
    //     window.location = "/cart"
    //   }
    // }
    if (Object.keys(socialLoginInfo).length > 0) {
      return (
        <div className="signUpPopup">
          <SignUpSocial
            socialLoginInfo={socialLoginInfo}
            viewSiteAs="desktop"
            queryString={search}
          />
        </div>
      );
    }
    const catstr = _get(this.props, 'match.params.catstr', '');
    if (catstr === 'signOut') {
      return null;
    }
    if (error && error.errorCode == '504') {
      return (
        <Layout category={false}>
          <Error504 name="home" device="desktop" />
        </Layout>
      );
    }
    if (error && error.errorCode == '503') {
      return <Error503 name="home" device="desktop" />;
    }

    const bannerdata = Object.keys(banner).length === 0 ? '' : banner;
    // if (Object.keys(bannerdata).length === 0) {
    //   return null;
    // }

    const { pageDetails = [] } = bannerdata;
    if (!isRuntimeBannerPage) {
      if (pageDetails.length === 0) {
        return <NotFoundPage />;
      }
    } else {
      if (
        _get(banner, 'data', []).length === 0 ||
        _get(banner, 'data.page', []).length === 0 ||
        _get(banner, 'data.page.slots', []).length === 0
      ) {
        return <NotFoundPage />;
      }
    }

    var components =
      !isRuntimeBannerPage &&
      pageDetails.map((pgDetails, i) => {
        const prevItem = pageDetails[i - 1];
        let componentTitle = '';
        const { application = '' } = pgDetails;
        const PLATFORM_BOOL = application ? this.checkMsitePlatform(application) : true;

        if (prevItem && prevItem.typeCode === 'NewTitleComponent' && PLATFORM_BOOL) {
          componentTitle = prevItem.title;
        }
        if (pgDetails.typeCode === 'WomenBannerComponent' && PLATFORM_BOOL) {
          let { banner: { bannerUrlLink = '', componentPosition = '' } = {} } = pgDetails;
          return (
            <LazyLoad
              className={`women-banner ${GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME} ${GTM_BANNER_COMPONENT_POSITION_CLASS_NAME}${componentPosition}`}
              key={i}
              offsetVertical={600}
              throttle={100}
              debounce={false}
              onContentVisible={() => {
                this.sendVisibilityEvent({ pgDetails, position: i });
              }}
            >
              <WomenBanner pagedetails={pgDetails} componentTitle={componentTitle} />
            </LazyLoad>
          );
        } else if (pgDetails.typeCode === 'NewIndieCollectionContainerComponent' && PLATFORM_BOOL) {
          return (
            <LazyLoad
              className="indiecollection"
              key={i}
              offsetVertical={600}
              throttle={100}
              debounce={false}
            >
              <IndieCollection pagedetails={pgDetails} componentTitle={componentTitle} />
            </LazyLoad>
          );
        } else if (PLATFORM_BOOL) {
          const COMPONENT_TYPE_CODE = BannerComponentJSON[pgDetails.typeCode]
            ? BannerComponentJSON[pgDetails.typeCode]
            : '';
          if (!COMPONENT_TYPE_CODE) return;

          const {
            componentClassName = '',
            Component = '',
            offsetVertical = 600,
            throttle = 100,
            debounce = false,
            gtmBannerEventEnabled = false,
            bannerProperty = ''
          } = COMPONENT_TYPE_CODE;
          const bannerCompPosition =
            gtmBannerEventEnabled === true && bannerProperty !== ''
              ? getBannerComponentPosition(pgDetails, bannerProperty)
              : '';
          const classString =
            bannerCompPosition === ''
              ? componentClassName
              : `${componentClassName} ${GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME} ${GTM_BANNER_COMPONENT_POSITION_CLASS_NAME}${bannerCompPosition}`;

          return (
            <LazyLoad
              key={i}
              offsetVertical={offsetVertical}
              throttle={throttle}
              debounce={debounce}
              className={classString}
              onContentVisible={this.sendVisibilityEvent({
                pgDetails,
                position: i
              })}
            >
              <Component pagedetails={pgDetails} componentTitle={componentTitle} />
            </LazyLoad>
          );
        }
      });

    let logoURL = `${properties.getProperty('imageBaseUrl')}/static/img/user-address.png`;
    let clickedList = []

    return (
      <>
        <div id="sr-init-focus" tabindex="-1" style={{position:'absolute', left:`-9999px`, height:`1px`, width:`1px`, overflow:`hidden`}}></div>
        <a
          className="skip-link"
          tabIndex={0}
          onClick={() => {
            window.location.href = '#main-content';
            const el = document.querySelector('.img-animate');
            if (el) {
              el.tabIndex = '-1';
              el.focus();
            }
          }}
        >
          Skip To Content
        </a>
        <Layout category={false} moveToTop={true}>
          {this.state.showEmailEditSuccess && localStorage.getItem('emailUpdateMsg') && (
            <div className="err-msg-blk">
              <ErrorMessage
                message={localStorage.getItem('emailUpdateMsg') || ''}
                showInfoIcon={false}
                showCloseButton={false}
              />
            </div>
          )}
          <div
            id='main-content'
            className="banner-components"
            onClickCapture={event => {
              let element = {};
              let { target: { parentElement = {}, tagName = '' } = {} } = event;
              if ((parentElement && parentElement.tagName === 'A') || tagName === 'A') {
                element = parentElement;
                if (tagName === 'A') {
                  element = event?.target;
                }
                let { location: { pathname: pageRoute = '' } = {} } = window || {};
                const isLandingPage = pageRoute.includes('shop');

                let { landing: { pageName = '', pageType = '' } = {} } = screen;
                pageName = '';
                if (!isLandingPage) {
                  pageType = 'home screen';
                }
                const promoPosition = element.getAttribute('data-gtm-bnr-position');
                if (!isRuntimeBannerPage) {
                  let eventObj = {};
                  eventObj.LinkUrl = element.getAttribute('href') || '';
                  eventObj.GaEventAction = element.getAttribute('data-ga-event-action') || '';
                  eventObj.GaEventLabel = element.getAttribute('data-ga-event-label') || '';
                  generateEvent({
                    Event: 'LandingPageBannerClick',
                    value: eventObj
                  });
                }

                if (promoPosition) {
                  setLandingPageScrollCookies('WEB');
                  const promoID = element.getAttribute('data-gtm-bnr-id');
                  const promoName = element.getAttribute('data-gtm-bnr-imgname');

                  let storeType = name || 'ajio';

                  /* For runtime banners */
                  if (isRuntimeBannerPage) {
                    const promoWidth = element.getAttribute('data-gtm-bnr-width') || 0;
                    const promoHeight = element.getAttribute('data-gtm-bnr-height') || 0;

                    let promoCreativeName = null;
                    if (
                      promoWidth &&
                      promoHeight &&
                      parseInt(promoWidth) !== 0 &&
                      parseInt(promoHeight) !== 0
                    ) {
                      promoCreativeName = `${promoWidth}x${promoHeight}`;
                    }
                    let isJioAds = element.getAttribute('data-gtm-bnr-isjioads');
                    let cid = element.getAttribute('data-gtm-bnr-jioads-cid') || '';
                    let jioAdsBannerName = element.getAttribute('data-gtm-bnr-jioads-desc');
                    const bannerType = element.getAttribute('data-ga-event-category');
                    const sclId = element.getAttribute('data-gtm-bnr-sclid');
                    const uclId = element.getAttribute('data-gtm-bnr-uclid');
                    const clientId = element.getAttribute('data-gtm-bnr-clientid');
                    const subscriptionDetails = element.getAttribute(
                      'data-gtm-bnr-subscription-details'
                    );

                    const storedValue = localStorage.getItem(STORAGE_KEY);
                    clickedList = storedValue ? JSON.parse(storedValue) : [];
                    if (clickedList.includes(promoID)) return;
                    localStorage.setItem(
                      STORAGE_KEY,
                      JSON.stringify([...clickedList, promoID])
                    );

                    newDesignLuxe
                      ? gtmLuxePromotionCmsClick(
                          promoID,
                          promoName,
                          promoCreativeName,
                          promoPosition,
                          storeType,
                          pageName,
                          pageType,
                          isJioAds,
                          cid,
                          jioAdsBannerName,
                          subscriptionDetails,
                          bannerType,
                          sclId,
                          uclId,
                          clientId
                        )
                      : gtmPromotionCmsClick(
                          promoID,
                          promoName,
                          promoCreativeName,
                          promoPosition,
                          storeType,
                          pageName,
                          pageType,
                          isJioAds,
                          cid,
                          jioAdsBannerName,
                          '',
                          '',
                          bannerType,
                          sclId,
                          uclId,
                          clientId
                        );

                    if (bannerType === 'EXTERNAL_AD') {
                      fireOsmosClickTracker(uclId, 'HOME', clientId);
                    } else {
                      const isJioAdBanner = element.getAttribute('data-gtm-bnr-isjioads') || false;
                      if (isJioAdBanner === 'true') {
                        const clicktracker =
                          element.getAttribute('data-gtm-bnr-jioads-clicktracker') || '';
                        const cid = element.getAttribute('data-gtm-bnr-jioads-cid') || '';
                        if (clicktracker?.length > 0) {
                          sendClickOrImpressionTrackerToJioAds(clicktracker, {
                            cid,
                            setCid: true,
                            jioAdsBannerName
                          });
                        }
                      } else {
                        newDesignLuxe
                          ? gtmLuxePromotionClick(promoID, promoName, null, promoPosition, storeType)
                          : gtmPromotionClick(
                              promoID,
                              promoName,
                              null,
                              promoPosition,
                            );
                      }
                    }
                  }
                }
              }
            }}
          >
            {!isRuntimeBannerPage ? components : <BannerComponentsRenderer />}

            {!sis ? (
              <div
                id="open-menu-button"
                className="ic-floating"
                data-ga-event-category="Page Interaction"
                data-ga-event-action="buttonTap"
                data-ga-event-label="fabButton"
                role="button"
                aria-label="Menu Option"
                tabIndex={0}
                onClick={() => {
                  console.log("On click:");
                  this.props.showModal('category-navigation');
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " " || event.code === "Space") {
                    console.log("Key pressed:", event.key);
                    setTimeout(() => {
                    // event.preventDefault();
                    this.clickMenuOptions();
                    }, 0);
                  }
                }}                
              />
            ) : (
              ''
            )}
            {!sis ? (
              <Modal name="category-navigation" className="modal-cat-nav">
                <PopUpCategoryNavigation />
              </Modal>
            ) : (
              ''
            )}
          </div>
          {getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags) ? (
            <ReferralCongratulations />
          ) : null}
          <Modal name="locale-banner-popup" onClose={this.handleModalClose}>
            <LocalePopUpForUserLocation
              image={logoURL}
              allowUserLocation={this.allowUserLocation}
              device="desktop"
              alt="Location image"
            />
          </Modal>
          <VideoModalBody />
          <BannerModal variant="desktop" />
          <DressToolModal />
        </Layout>
      </>
    );
  }

  locationPopup = (isLocationCheck = false) => {
    const userId = decodeURIComponent(readCookie('U')) || '';
    const pinCode = readCookie('PC') || '';
    if (signInCheck().length) {
      let data = JSON.parse(sessionStorage.getItem('customerTypeData')) || '';
      if (Object.keys(data).length > 0) {
        this.props.savedCustomerTypeData(data);
      } else if (pinCode.length) {
        this.props.updateNonLoginUserPinCodeLocaleChanges(
          pinCode,
          this.checkUserLocationPermissionAccess
        );
      } else {
        this.props.updateLoginUserLocaleChanges(userId, this.checkUserLocationPermissionAccess);
      }
    } else {
      if (pinCode.length) {
        this.props.updateNonLoginUserPinCodeLocaleChanges(
          pinCode,
          this.checkUserLocationPermissionAccess
        );
      } else {
        !isLocationCheck && this.checkUserLocationPermissionAccess();
      }
    }
  };

  async checkSocialAuthAcc(socialAuthObj, socialAuth) {
    try {
      const resp = await socialAuth(socialAuthObj);
      if (resp) {
        window.location.reload();
      }
    } catch (err) {
      window.location = '/login';
    }
  }

  checkAccountForLogin = (res, credential) => {
    if (credential) {
      let { name = '', email = '' } = res;
      let usernameObj = { emailId: email };
      this.props.accountCheck(usernameObj, async response => {
        const socialAuthConfig = {
          login: email,
          loginvia: 'google',
          token: credential
        };
        if (Object.keys(response).length >= 1) {
          let { success = false, socialLogin = 'false' } = response;
          const socialAuthObj = {
            ...socialAuthConfig
          };
          if (success && socialLogin == 'true') {
            this.checkSocialAuthAcc(socialAuthObj, this.props.socialAuth);
          } else if (success && socialLogin == 'false') {
            const socialAuthObj = {
              ...socialAuthConfig,
              firstName: name,
              password: '',
              genderType: '',
              requestType: requestType.SENDOTP
            };
            this.checkSocialAuthAcc(socialAuthObj, this.props.socialAuth);
          } else if (!success) {
            // window.location = "/signup/social";
            this.props.setSignupSocial(socialAuthObj);
          }
        }
      });
    }
  };

  openShopTheLookModal = () => {
    const { href, search } = window.location;
    let hash = '';
    let hashIndex = href.indexOf('#');
    if (hashIndex > 0) hash = href.substring(hashIndex + 1);
    const urlParams = new URLSearchParams(search);
    const bannerInRow = urlParams.get('currentBannerInRow');
    const bannerId = urlParams.get('BannerId');

    let bannerData = this.props.slots?.filter(slot => {
      return (
        _get(slot, 'component.type') === 'SHOPTHELOOK' &&
        parseInt(bannerId) === _get(slot, 'rowNumber')
      );
    });
    if (hash === 'ShopTheLook' && bannerData?.length > 0) {
      this.props.showModal('banner-modal', {
        state: {
          currentBannerInRow: parseInt(bannerInRow),
          variant: 'desktop',
          allBanners: bannerData[0].component.banners,
          rowNumber: parseInt(bannerId)
        }
      });
      const updateURLParams = removeParameters(href, 'BannerId', 'currentBannerInRow');
      window.history.replaceState(null, '', `${updateURLParams.split('#')[0]}`);
    }
  };
  componentDidMount() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
    const catstr = _get(this.props, 'match.params.catstr', '');
    if (catstr === 'signOut') {
      this.props.signout(() => {
        window.location = '/';
      });
    }
    localStorage.removeItem('jioAdsBannerPromoIdDataListWeb');
    if (localStorage.getItem('emailUpdateMsg')) {
      this.setState({
        showEmailEditSuccess: true
      });
      setTimeout(() => {
        localStorage.removeItem('emailUpdateMsg');
        this.setState({
          showEmailEditSuccess: false
        });
      }, 5000);
    }

    removeBannerImpressionCookiesOnPageReloaded('WEB');
    this.openShopTheLookModal();
    let { location: { pathname: pageRoute = '' } = {} } = window || {};
    const isLandingPage = pageRoute.includes('shop');
    const {
      location: { search = '' },
      flags
    } = this.props;
    const {
      jioAdsSpecs: { sdkParams = {} } = {},
      jioAdsLandingPagesExperiment = '',
      landingPagesExperiments = []
    } = flags;

    let self = this;

    window.handleToken = function(res) {
      if (res) {
        const { credential = '' } = res;
        const decodedResponse = parseJwt(credential);
        self.checkAccountForLogin(decodedResponse, credential);
      }
    };
    window.logMomentNotification = function(notification) {
      if (notification.getNotDisplayedReason() && notification.isNotDisplayed()) {
        // self.locationPopup();
      }
    };
    // this.props.runtimeBanners==="ON"
    const isLoggedInUser = signInCheck();
    let isLocationCheck = false;
    const pinCode = readCookie('PC') || null;
    if (this.props.isRuntimeBannerPage) {
      if (
        !search.includes('isPreview') &&
        !this.props.isBanerUpdateRequired &&
        !isLoggedInUser &&
        !pinCode
      ) {
        this.checkUserLocationPermissionAccess();
        isLocationCheck = true;
      }
    }
    this.locationPopup(isLocationCheck);
    // GTM events setup
    window.addEventListener('load', () => {
      setLandingPageScroll('WEB');
      if (typeof window !== 'undefined') {
        let jioSDKvalues = window.JioAds?.getRequestParams();
        let sdkParamsList = Object.keys(sdkParams);
        sdkParamsList.forEach(sdkParamKey => {
          if (jioSDKvalues?.[sdkParamKey] !== undefined)
            createCookie(sdkParamKey, jioSDKvalues?.[sdkParamKey], 1);
        });
      }

      !signInCheck() && initaliseSmartLock();
      const bannersHTMLElements = document.querySelectorAll(
        `.${GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME}`
      );
      const {
        metaData: { name = '', sis = '' } = {},
        newDesignLuxe,
        clusterFeatureFlag
      } = this.props;
      let { landing: { pageName = '', pageType = '' } = {} } = screen;
      pageName = '';
      if (!isLandingPage) {
        pageType = 'home screen';
      }
      gtmPagePush(pageName, pageType, window.__ENV__ || '', {
        page_type_screen: pageRoute,
        store: name,
        number_of_banners: bannersHTMLElements.length || '',
        user_personalization_bucket: clusterFeatureFlag ? readClusterCookie('cluster', name) : '',
        serviceName: 'cms'
      });

      if (this.props.isRuntimeBannerPage) {
        let storeType = name || 'ajio';

        self.gtmBannerViewportObserver = createCmsGTMBannerViewPortIntersectionObserverDesktop(
          bannersHTMLElements,
          newDesignLuxe ? gtmLuxePromotionCmsImpressions : gtmPromotionCmsImpressions,
          newDesignLuxe,
          storeType,
          pageName,
          pageType
        );
      } else {
        self.gtmBannersData = [...triggerLandingPageGtmMetaEvent(self.props, gtmExtraInfoMeta)];
        self.gtmBannerViewportObserver = createGTMBannerViewPortIntersectionObserverDesktop(
          self.gtmBannersData,
          bannersHTMLElements,
          newDesignLuxe ? gtmLuxePromotionImpressions : gtmPromotionImpressions,
          self.gtmBannersImpressionData,
          newDesignLuxe
        );
      }

      const srFocus = document.getElementById('sr-init-focus');
      if (srFocus) {
        srFocus.focus({ preventScroll: true });

        const skipLink = document.getElementById('skip-link');
        if (skipLink) {
          skipLink.focus({ preventScroll: true });
        }
      }
      window.addEventListener('beforeunload', () => {
        handleRemainingBundlePromotionImpression('WEB');
        if (newDesignLuxe) this.sendRemainingImpressions;
      });
      updateClusterCookie(name, clusterFeatureFlag);
    });
    const isSignedIn = signInCheck().length;
    const isMiniApp = sessionStorage.getItem('gpay') || sessionStorage.getItem('phonepe');
    if (!isMiniApp && isSignedIn) {
      // TODO: commenting it till next release implementation
      // this.cleverTapPopup();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.sendRemainingImpressions);
  }

  sendRemainingImpressions = () => {
    const { newDesignLuxe } = this.props;
    if (newDesignLuxe) {
      const { banners = [] } = this.gtmBannersImpressionData;
      if (banners.length > 0) {
        gtmLuxePromotionImpressions(banners);
        this.gtmBannersImpressionData = {
          banners: [],
          lastPushedAt: -1,
          oldBanners: []
        };
      }
    }
  };
}
function initaliseSmartLock() {
  google.accounts.id.initialize({
    client_id: `${properties.getProperty('googleClientId')}`,
    callback: handleToken,
    cancel_on_tap_outside: false,
    skip_prompt_cookie: 'U'
  });
  google.accounts.id.prompt();
}

function mapStateToProps(state) {
  const { httpError = {}, metaData = {}, signInReducer = {}, flags = {}, bannerInfo } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const error = httpError.home;
  const clusterFeatureFlag = getClusterFeatureFlagHome(flags);
  const { socialLoginInfo = {} } = signInReducer;
  return {
    banner: state.banner,
    error,
    metaData,
    socialLoginInfo,
    runtimeBanners: getRuntimeBannersFlag(flags),
    runtimeBannersUrlList: getRuntimeBannersUrlList(flags),
    isBanerUpdateRequired: bannerInfo.isBanerUpdateRequired,
    isRuntimeBannerPage: bannerInfo.isRuntimeBannerPage,
    flags,
    newDesignLuxe,
    clusterFeatureFlag,
    slots: _get(state, 'banner.data.page.slots', [])
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updateLoginUserLocaleChanges: (userId, callback) => dispatch(getLocaleData(userId, callback)),
    savedCustomerTypeData: userId => dispatch(savedCustomerTypeData(userId)),
    updateNonLoginUserPinCodeLocaleChanges: (postalCode, callback) =>
      dispatch(postalCodeFetch({ postalCode }, callback)),
    updateNonLoginUserLocationLocaleChanges: (optionalObject = {}) =>
      dispatch(userAllowedLocationForLocale(optionalObject)),
    updateNonLoginUserLocationUsingRuntimeLocaleChanges: (optionalObject = {}) =>
      dispatch(userAllowedLocationForRuntimeLocale(optionalObject)),
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    signout: callback => {
      dispatch(signout(callback));
    },
    accountCheck: (formData, callback) => {
      dispatch(accountCheck(formData, callback));
    },
    socialAuth: (formData, callback, device) => {
      return dispatch(socialAuth(formData, callback, device));
    },
    setSignupSocial: socialAuthObj => {
      dispatch(setSignupSocial(socialAuthObj));
    }
  };
};
export default BannerComponent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BannerComponent)
);
